import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { addItem } from "../../../redux/slices/CartSlice";
import CheckoutModal from "../CheckoutModal/CheckoutModal";
import GradientButton from "../../Buttons/GradientButton/GradientButton";
import NftInteractionModal from "../NftInteractionModal/NftInteractionModal";
import StyledMdText from "../../../common/components/styledMdText/StyledMdText";
import StyledH5Heading from "../../../common/components/styledH5Heading/StyledH5Heading";
import { useAccount } from "wagmi";
import { useCartNfts } from "../../../Hooks/api/useCartNfts";

const SingleNftModule = ({ closeModal, nft }) => {
  const [showCheckoutModal, setShowCheckoutModal] = useState(false);
  const { mutate: handleCartNft } = useCartNfts();
  const { address } = useAccount();

  const dispatch = useDispatch();

  const handleAddToCart = () => {
    dispatch(addItem(nft));

    handleCartNft({
      nftId: nft.nft_id,
      walletAddress: address,
      action: "add",
      contract_address:process.env.REACT_APP_CONTRACT_ADDRESS
    });
  };

  const handleButtonClick = () => {
    setShowCheckoutModal(true);
  };

  const NftData = [
    { title: "Tier", value: nft.tier },
    { title: "NFT Name", value: nft.name },
    { title: "Background", value: "Dark Red Black" },
    { title: "Variant", value: "Golden finish" },
    { title: "Price", value: nft.price, icon: "/assets/price-icon.svg" },
  ];

  return (
    <NftInteractionModal
      handleClose={closeModal}
      width={"w-[95%] sm:w-4/5 md:w-3/4 lg:w-4/6 xl:w-1/2 h-full md:h-auto"}
      content={
        <div className="w-full h-full flex flex-col md:flex-row md:gap-10 md:p-4 overflow-auto no-scrollbar">
          <div className="md:min-w-[50%] lg:w-full xl:w-[50%] ">
            <img className="h-full w-full" src={nft.image} alt="NFT's" />
          </div>
          <div className="w-full xl:w-[35%] p-4 md:p-0">
            {NftData.map((item, index) => (
              <StyledH5Heading key={index} className="mb-4 ">
                <StyledMdText fontColor={"text-bright-yellow"}>
                  {item.title}
                </StyledMdText>
                {item.icon && item.title === "Price" ? (
                  <span className="flex items-center">
                    <img src={item.icon} alt="Price Icon" loading="lazy"/>
                    <span className="ml-2">{item.value}</span>
                  </span>
                ) : (
                  item.value
                )}
              </StyledH5Heading>
            ))}
          {!nft.minted && <div className="flex  justify-between gap-2 w-full">
              <GradientButton
                onClick={handleButtonClick}
                fontColor={"w-full text-nowrap"}
                children={"Buy Now"}
                disabled={nft.minted}
              ></GradientButton>
              <GradientButton disabled={nft.minted} onClick={handleAddToCart}>
                <img
                  src="/assets/cart-black.svg"
                  alt="Add to cart"
                  width={22}
                />
              </GradientButton>
            </div>}
          </div>
          {showCheckoutModal && (
            <CheckoutModal
              key={nft.id}
              nft={nft}
              closeModal={() => setShowCheckoutModal(false)}
            />
          )}
        </div>
      }
    />
  );
};

export default SingleNftModule;
